module.exports = __webpack_public_path__ + "static/whzxyy-caa46ee689d1a08711a9c79cc30e3116.jpg";